import { App as AntApp, ConfigProvider } from 'antd';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { IsMobileProvider } from '@/context/IsMobileContext.tsx';
import { NotificationProvider } from '@/context/NotificationContext.tsx';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { routes } from '@/router/routes.tsx';
import { Sentry } from '@/config/sentry';

function App() {
  const router = createBrowserRouter(routes);

  return (
    <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
      <NotificationProvider>
        <IsMobileProvider>
          <QueryClientProvider client={queryClient}>
            <ConfigProvider theme={theme}>
              <AntApp>
                <RouterProvider router={router} />
              </AntApp>
            </ConfigProvider>
            <ReactQueryDevtools initialIsOpen={false} />
          </QueryClientProvider>
        </IsMobileProvider>
      </NotificationProvider>
    </Sentry.ErrorBoundary>
  );
}

function ErrorFallback() {
  return (
    <div style={{ padding: 24, fontFamily: 'system-ui' }}>
      <h2>Something went wrong</h2>
      <p>The error has been reported. Try reloading the page.</p>
      <button onClick={() => window.location.reload()}>Reload</button>
    </div>
  );
}

export default App;

const queryClient = new QueryClient({
  defaultOptions: {
    mutations: {
      retry: false,
    },
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const theme = {
  token: {
    colorPrimary: '#1668dc',
    colorSuccess: '#52C41A',
    colorError: '#FF4D4F',
    colorTextBase: '#262626',
    borderRadius: 4,
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  },
  cssVar: true,
  hashed: false,
};
